import React from 'react';
import { Data, ExtractDataType, isDataLoaded, makeLoadedData } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ManageAlarmManager from '../domain/manage-alarms-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { PromiseType } from '../../types';
import _ from 'lodash';

export type DeviceChannelCount = PromiseType<ReturnType<typeof ManageAlarmManager.getDeviceChannelCount>>;
type ContextState = Data<DeviceChannelCount>;
const Context = React.createContext<ContextState | null>(null);

function useDeviceChannelCount(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useDeviceChannelCount must be used within a SierraChildDeviceDetailsProvider');
    }
    return contextState;
}

const DeviceChannelCountProvider: React.FC<{ siteId: string; gatewayId: string; deviceType: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'device-channel-count',
        id: `${props.siteId}-${props.gatewayId}-${props.deviceType}`,
        dataFn: React.useCallback(
            () => ManageAlarmManager.getDeviceChannelCount(authHelper, props.siteId, props.gatewayId, props.deviceType),
            [authHelper, props.siteId, props.gatewayId, props.deviceType]
        ),
    });

    const deviceChannelCountData = dataFromDataset(dataset);
    const value = React.useMemo(() => {
        if (!isDataLoaded(deviceChannelCountData)) {
            return deviceChannelCountData;
        }

        // if (!isDataLoaded(deviceChannelCountData)) {
        //     return channelData;
        // }
        if (deviceChannelCountData && deviceChannelCountData.value) {
            return makeLoadedData<ExtractDataType<ContextState>>(
                deviceChannelCountData.value
                    .filter((channelDatum) => !_.isNil(channelDatum.deviceId) && !_.isNil(channelDatum.deviceName))
                    .map((deviceChannel) => ({
                        deviceId: deviceChannel.deviceId,
                        deviceName: deviceChannel.deviceName,
                        channelCount: deviceChannel.channelCount,
                    }))
            );
        } return makeLoadedData<ExtractDataType<ContextState>>([])
    }, [deviceChannelCountData]);
    return <Context.Provider value={value}>{props.children}</Context.Provider>;
};

const TestStarfishChildDeviceDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { DeviceChannelCountProvider, TestStarfishChildDeviceDataProvider, useDeviceChannelCount };
